import {LiveStreamingNavigationPrevButtonDefaultBox, LiveStreamingNavigationNextButtonDefaultBox, LiveStreamingLeftCutDefaultBox, LiveStreamingRightCutDefaultBox} from "./live-streaming-navigation.default.box";

export const LiveStreamingNavigationPrevButtonBox = LiveStreamingNavigationPrevButtonDefaultBox;
export const LiveStreamingNavigationNextButtonBox = LiveStreamingNavigationNextButtonDefaultBox;

export const LiveStreamingLeftCutBox = LiveStreamingLeftCutDefaultBox;
export const LiveStreamingRightCutBox = LiveStreamingRightCutDefaultBox;
